/* HAND-AUTHORED (the artifact pipeline was unavailable for this stage) — stage "x-latency".
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_X_LATENCY: NodeDef = {
  "id": "x-latency",
  "tagKey": "path:x-latency.tag",
  "x": 1216,
  "y": 700,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-latency.title",
  "subKey": "path:x-latency.sub",
  "blocks": [
    {
      "id": "x-latency.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-latency.b1.title",
      "bodyKey": "path:x-latency.b1.body",
      "flowKey": "path:x-latency.b1.flow",
      "read": [
        "sarathi"
      ]
    },
    {
      "id": "x-latency.b2",
      "kind": "math",
      "xp": 25,
      "titleKey": "path:x-latency.b2.title",
      "math": {
        "exprKey": "path:x-latency.b2.math.expr",
        "readKey": "path:x-latency.b2.math.read",
        "useKey": "path:x-latency.b2.math.use",
        "ref": "sarathi",
        "ref2": "vllm"
      }
    },
    {
      "id": "x-latency.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-latency.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-latency.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-latency.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-latency.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-latency.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-latency.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-latency.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-latency.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-latency.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "production"
};